import { memo } from "react";
import styled from "styled-components";

import { PATH_FAVORITES, PATH_SEARCH_RESULT } from "@routes";
import { ITourElement } from "@interfaces";
import { StyledTourElementMain, StyledTourElement } from "@components";
import { getDisplayPriceWithOriginal, theme } from "@utilities";
import useImageFallback from "src/Utilities/imageFallbackHelper";
import { getTour, useAppDispatch, useIsLoggedIn } from "@redux";
import { cacheApi } from "@api";
import { sessionHelper } from "@utilities";

interface IProps {
    data: ITourElement;
}

export const TourElementModule = memo((props: IProps) => {
    const dispatch = useAppDispatch();
    const isLoggedIn = useIsLoggedIn();
    const pathname = window.location.pathname;
    const {
        productImagePath,
        name,
        location,
        durationDays,
        durationNight,
        productSmallToMediumSizeImagePath,
        productLargeSizeImagePath,
    } = props.data;
    const Fragment = StyledTourElementMain;

    let duringTime = "";
    if (Number(durationDays) > 0) {
        duringTime += `${durationDays} ${Number(durationDays) === 1 ? "day" : "days"}`;
    }
    if (Number(durationDays) > 0 && Number(durationNight) > 0) {
        duringTime += " , ";
    }
    if (Number(durationNight) > 0) {
        duringTime += `${durationNight} ${Number(durationNight) === 1 ? "night" : "nights"}`;
    }

    const imageSrc = useImageFallback({
        productImagePath,
        productSmallToMediumSizeImagePath,
        productLargeSizeImagePath,
    });

    const ProductPriceMessage = (faresPrices: ITourElement["faresprices"]) => {
        return getDisplayPriceWithOriginal(faresPrices || []);
    };

    const { price, originalPrice } = ProductPriceMessage(props.data.faresprices);

    return (
        <StyledTourElement>
            <div
                className={`heart ${pathname === PATH_SEARCH_RESULT ? "searchResultPage" : ""}`}
                style={pathname.includes("favorites") ? { right: "15px" } : {}}
            ></div>
            <Fragment
                to={`/detail-tour/${props.data.productId}`}
                style={pathname.includes("favorites") ? { width: "unset", margin: 0 } : {}}
                onClick={async () => {
                    if (!isLoggedIn) {
                        if (sessionHelper.hasSession()) {
                            cacheApi.cacheProduct(props.data.productId.toString(), sessionHelper.getSessionId());
                        }
                    } else {
                        cacheApi.cacheProduct(props.data.productId.toString());
                    }
                    await dispatch(getTour(props.data.productId));
                }}
            >
                <div
                    className="tour_image"
                    style={{
                        backgroundImage: `url(${imageSrc})`,
                    }}
                ></div>
                <div className="main">
                    <div className="info">
                        <p className="destination__title">{name}</p>
                        <p className="destination__place">
                            <span className="placeName">{location}</span>
                        </p>
                    </div>
                    <div className="durationNPrice">
                        <div className="destination__price">
                            <span className="form">From</span>
                            <span className="price" style={theme.colors.price ? { color: theme.colors.price } : {}}>
                                {originalPrice && (
                                    <DiagonalSlashPrice $hasSlash={!!theme.colors.price}>
                                        {originalPrice}
                                    </DiagonalSlashPrice>
                                )}
                                {price}
                            </span>
                        </div>

                        <div className="destination__duration">
                            <span className="time">{duringTime}</span>
                        </div>
                    </div>
                </div>
            </Fragment>
        </StyledTourElement>
    );
});

const DiagonalSlashPrice = styled.span<{ $hasSlash: boolean }>`
    position: relative;
    margin-right: 4px;
    color: #828282;
    ${(props) =>
        props.$hasSlash
            ? `
        text-decoration: none;
        &::after {
            content: '';
            position: absolute;
            left: -2px;
            right: -2px;
            top: 0;
            bottom: 0;
            background: linear-gradient(
                to top left,
                transparent calc(50% - 1px),
                ${props.theme.colors.price || '#828282'} calc(50% - 1px),
                ${props.theme.colors.price || '#828282'} calc(50% + 1px),
                transparent calc(50% + 1px)
            );
        }
    `
            : `text-decoration: line-through;`}
`;
